// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__36D3l","consentsList":"PatientConsents_consentsList__3Wgnf","consentsListEmpty":"PatientConsents_consentsListEmpty__7uDft"};